import { render, staticRenderFns } from "./TrafiklabSettingPanel.vue?vue&type=template&id=0b4d7e86&scoped=true"
import script from "./TrafiklabSettingPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrafiklabSettingPanel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TrafiklabSettingPanel.vue?vue&type=style&index=0&id=0b4d7e86&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4d7e86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b4d7e86')) {
      api.createRecord('0b4d7e86', component.options)
    } else {
      api.reload('0b4d7e86', component.options)
    }
    module.hot.accept("./TrafiklabSettingPanel.vue?vue&type=template&id=0b4d7e86&scoped=true", function () {
      api.rerender('0b4d7e86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/appWidgetPanel/trafiklabSettingPanel/TrafiklabSettingPanel.vue"
export default component.exports